import { css } from 'emotion';
import { CSSProperties } from 'react';
import colors from '../utils/colors';

export default {
    leftContent: {
        flex: 0.6,
        maxWidth: 800,
        marginRight: 40
    },
    rightContent: {
        flex: 0.4
    },
    barContainer: {},
    mapContainer: {
        borderRadius: 12,
        borderWidth: 2,
        marginTop: 12,
        borderColor: colors.border,
        borderStyle: 'solid',
        marginBottom: 40,
        overflow: 'hidden'
    },
    cardContent: {
        margin: '24px 8px'
    },
    map: {
        width: 'flex',
        height: 360
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        color: colors.title
    },
    statusDescription: {
        marginTop: 12,
        marginBottom: 24,
        color: colors.paragraph
    },
    jobName: {
        fontSize: 16,
        marginTop: 12,
        marginBottom: 12,
        color: colors.paragraph
    },
    orderName: {
        fontSize: 16,
        marginTop: 8,
        marginBottom: 8,
        color: colors.paragraph
    },
    etaTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        paddingBottom: 4,
        color: colors.title
    },
    etaTime: {
        fontSize: 32,
        fontWeight: 'bold',
        paddingBottom: 8,
        color: colors.title
    },
    etaMessage: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 16,
        gap: 8,
        marginBottom: 36,
        color: 'orange',
        fontStyle: 'italic'
    },
    etaTimeDescription: {
        fontSize: 14,
        paddingLeft: 4,
        color: colors.paragraph
    },
    detailSubtitle: {
        fontWeight: 'bold',
        fontSize: 16,
        color: colors.title,
        marginTop: 28
    },
    subtitle: {
        fontWeight: 'bold',
        color: colors.title,
        fontSize: 16
    },
    lineDivider: {
        marginTop: 30,
        marginBottom: 20,
        height: 1,
        width: '100%',
        backgroundColor: colors.border
    },
    titleRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom: 24
    },
    iconCircle: {
        width: 48,
        height: 48,
        borderRadius: 24,
        backgroundColor: colors.successBackground,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 16
    },
    itemDetailsRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 30,
        marginRight: 20
    },
    columnPadding: {
        marginRight: 40
    },
    itemField: {
        marginTop: 8,
        fontSize: 16,
        color: colors.paragraph
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 8,
        color: colors.paragraph
    },
    tip: {
        marginTop: 8,
        fontSize: 16,
        color: colors.paragraph
    },
    orderDetail: {
        fontSize: 16,
        marginLeft: 12
    },
    bottomPadding: {
        height: 40
    }
} as Record<string, CSSProperties>;

export const cssStyles = {
    container: css`
        display: flex;
        flex: 1;
        flex-direction: column;
        font-family: aktiv-grotesk, Helvetica, Open Sans, sans-serif;
        overflow-y: auto;
    `,
    contentContainer: css`
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        padding-top: 40px;
        padding-left: 100px;
        padding-right: 100px;
        justify-content: flex-start;

        @media (min-width: 1000px) {
            flex-direction: row;
            justify-content: center;
        }
    `,
    widgetContainer: css`
        width: 100%;
        max-width: 400px;
        margin-right: auto;
        @media (min-width: 1000px) {
            flex: 1;
            overflow-y: auto;
        }
    `
};
